import MyImage from "../../assets/images/image.jpg";

const MySVGComponent = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1498 2891">
      {/* Background Image */}
      <image width="1498" height="2891" xlinkHref={MyImage} />

      {/* Clickable Rectangles */}
      <a xlinkHref="#">
        <rect x="0" y="0" fill="#fff" opacity="0" width="100" height="100" />
      </a>

      <a xlinkHref="https://forms.office.com/pages/responsepage.aspx?id=DzBIyn8LE0CoYRnHcADgUyZ-lfYANmFLtXMBSsdsXjNUN1JFNUc4RzlJNTFKTlM2TjQ0WTFLVlRRNS4u&route=shorturl">
        <rect x="136" y="2590" fill="#fff" opacity="0" width="414" height="100" />
      </a>

      <a xlinkHref="https://forms.office.com/pages/responsepage.aspx?id=DzBIyn8LE0CoYRnHcADgUyZ-lfYANmFLtXMBSsdsXjNUN1JFNUc4RzlJNTFKTlM2TjQ0WTFLVlRRNS4u&route=shorturl">
        <rect x="979" y="1342" fill="#fff" opacity="0" width="427" height="100" />
      </a>
    </svg>
  );
};

// function Basic() {
//   const appStyle = {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "100%",
//     margin: 0,
//     backgroundColor: "#000", // Optional: background color
//   };

//   const imgStyle = {
//     maxWidth: "100%",
//     maxHeight: "100%",
//   };

  

//   // return (
//   //   <>
//   //     <div style={appStyle}>
//   //       {/* <img src={MyImage} alt="Image" style={imgStyle} useMap="#imgmap202521312326" /> */}
//   //       {/* <img src={MyImage} useMap="#image-map" /> */}

//   //       {/* <map id="imgmap202521312326" style={{ cursor: "pointer" }} name="imgmap202521312326">
//   //         <area
//   //           shape="rect"
//   //           alt="Microsoft Form"
//   //           title=""
//   //           coords="999,1331,1373,1475"
//   //           href="https://forms.office.com/pages/responsepage.aspx?id=DzBIyn8LE0CoYRnHcADgUyZ-lfYANmFLtXMBSsdsXjNUN1JFNUc4RzlJNTFKTlM2TjQ0WTFLVlRRNS4u&amp;amp;route=shorturl"
//   //           target="_self"
//   //         />
//   //         <area
//   //           shape="rect"
//   //           alt="Microsoft Form"
//   //           title=""
//   //           coords="141,2563,525,2727"
//   //           href="https://forms.office.com/pages/responsepage.aspx?id=DzBIyn8LE0CoYRnHcADgUyZ-lfYANmFLtXMBSsdsXjNUN1JFNUc4RzlJNTFKTlM2TjQ0WTFLVlRRNS4u&amp;amp;route=shorturl"
//   //           target="_self"
//   //         />
//   //       </map> */}

//   //       {/* <map name="image-map">
//   //         <area
//   //           target=""
//   //           alt="Microsoft Form"
//   //           title="Microsoft Form"
//   //           href="https://forms.office.com/pages/responsepage.aspx?id=DzBIyn8LE0CoYRnHcADgUyZ-lfYANmFLtXMBSsdsXjNUN1JFNUc4RzlJNTFKTlM2TjQ0WTFLVlRRNS4u&amp;amp;route=shorturl"
//   //           coords="1372,1490,1000,1312"
//   //           shape="rect"
//   //         />
//   //         <area
//   //           target=""
//   //           alt="Microsoft Form"
//   //           title="Microsoft Form"
//   //           href="https://forms.office.com/pages/responsepage.aspx?id=DzBIyn8LE0CoYRnHcADgUyZ-lfYANmFLtXMBSsdsXjNUN1JFNUc4RzlJNTFKTlM2TjQ0WTFLVlRRNS4u&amp;amp;route=shorturl"
//   //           coords="521,2739,155,2550"
//   //           shape="rect"
//   //         />
//   //       </map> */}
//   //     </div>
//   //   </>
//   // );
// }

export default MySVGComponent;
